import React from 'react'
import { Navigate, useOutletContext, useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'
import RoutedMenu from '../../../../RoutedMenu/RoutedMenu'
import { hasPolicy } from '../../../../../redux/selectors'
import {
  ACCESS_LISTING_USER_PERMISSIONS_TAB,
  EDIT_INTEGRATION_SETTINGS,
} from '../../../../../auth/policies'
import { getPartnerListingPath } from '../../../../../setup/routeConstants'
import useCatalog from './Integrations/useCatalog'

export function SettingsTab() {
  const {
    affiliate,
    verificationListing,
    partner,
    listing,
    canUpdate,
    canUpdateBillingRules,
    subTab,
  } = useOutletContext()

  const canEditIntegrationSettings = useSelector(hasPolicy(EDIT_INTEGRATION_SETTINGS))
  const canAccessListingUserPermissionsTab = useSelector(
    hasPolicy(ACCESS_LISTING_USER_PERMISSIONS_TAB),
  )
  const { id: partnerListingId } = useParams()
  const { openManufacturerModal } = useCatalog()

  const items = []

  if (canEditIntegrationSettings) {
    items.push({
      label: 'Connections',
      to: 'integrations',
    })
  }

  if (canAccessListingUserPermissionsTab && verificationListing) {
    items.push({
      label: 'Permissions',
      to: 'user-permissions',
    })
  }

  // Neither settings policy is granted (e.g. direct navigation to a settings sub-route);
  // don't mount the Outlet, which would otherwise render an unauthorized sub-section.
  if (items.length === 0) {
    return <Navigate to={getPartnerListingPath(partnerListingId)} replace />
  }

  return (
    <div style={{ margin: '30px 0 0 0' }}>
      <RoutedMenu
        activeTab={subTab}
        items={items}
        context={{
          affiliate,
          verificationListing,
          partner,
          listing,
          canUpdate,
          canUpdateBillingRules,
          partnerListingId,
          canEditIntegrationSettings,
          canAccessListingUserPermissionsTab,
          openManufacturerModal,
        }}
      />
    </div>
  )
}

export default SettingsTab
